import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getZonesAPI() {
  const url = `${AWS_API_URL}/2n/zones`;
  return getRequest(url, await authorize());
}

